/** Drop server-only personnummer fields from client-side user objects (incl. stale cache merges). */
const STRIP_KEYS = ["personnummer_encrypted", "personnummer_last4", "personnummer"];

export function stripPersonnummerStorageFields(user) {
  if (!user || typeof user !== "object") return user;
  const out = { ...user };
  for (const key of STRIP_KEYS) {
    delete out[key];
  }
  return out;
}

export function stripPersonnummerStorageFieldsList(users) {
  return (users || []).map(stripPersonnummerStorageFields);
}
